module.exports = __webpack_public_path__ + "img/cerveza.f822e8b8.png";